import React, { useEffect } from "react";
import { connect } from "react-redux";
import { defaultAction } from "@actions/defaultAction";

import { COMPLETE_ORDER_SELL } from "@constants/actionTypes";

const SellOrderCompleteWrapper = ({
  children,
  checkoutOrdersSell,
  checkoutOrdersSellID,
  completeSellOrder,
  customerInfo
}) => {
  const round = (val, percent) =>
    Math.round((Number(percent) / 100) * Number(val), 2).toFixed(2);

  useEffect(() => {
    const sellOrderToRender = checkoutOrdersSell[checkoutOrdersSellID];
    const orderID = sellOrderToRender.orderId;

    const dataLayer = window.dataLayer || [];

    const transactionArray = checkoutOrdersSell.allSellCards.map(card => ({
      sku: card.id,
      price: round(card.enteredValue, card.sellPercentage),
      quantity: 1,
      name: card.merchantName
    }));

    const dataLayerObjectToPush = {
      event: "sell-conversion",
      sellOrderNumber: orderID,
      sellType: sellOrderToRender.requestedPaymentMethod,
      sellValue: sellOrderToRender.cardsValue,
      transactionId: orderID,
      transactionAffiliation: "cardcashSell",
      transactionTotal: sellOrderToRender.cardsValue,
      transactionTax: 0,
      transactionProducts: transactionArray
    };

    if (
      sellOrderToRender.trackingData?.affiliateBroker &&
      sellOrderToRender.trackingData.affiliateBroker === "rakuten"
    ) {
      let cardDataForRakuten = checkoutOrdersSell.allSellCards.map(card => ({
        SKU: card.id,
        quantity: 1,
        unitPrice: round(card.enteredValue, card.sellPercentage),
        unitPriceLessTax: round(card.enteredValue, card.sellPercentage),
        productName: card.merchantName,
        optionalData: {
          brand: card.merchantName
        }
      }));

      dataLayerObjectToPush.rakutenCustomerID = customerInfo.id;
      dataLayerObjectToPush.rakutenProducts = cardDataForRakuten;
      dataLayerObjectToPush.rakutenCustomerStatus = customerInfo.isNewSellCustomer
        ? "New"
        : "Returning";
      dataLayerObjectToPush.rakutenSegment =
        customerInfo.rakutenData.sellTotal >= 10000 ? 1 : 0;
    }

    dataLayer.push({
      ...dataLayerObjectToPush
    });

    return () => {
      completeSellOrder();
    };
  }, []);
  return <>{children}</>;
};

export default connect(
  state => ({
    checkoutOrdersSell: state.checkoutOrdersSell,
    customerInfo: state.customerInfo
  }),
  dispatch => ({
    completeSellOrder: () => dispatch(defaultAction(COMPLETE_ORDER_SELL))
  })
)(SellOrderCompleteWrapper);
